export default __webpack_public_path__ + "1adb0fb12782b85048e9b62737d3a948.svg";